<template>
  <div id="app" v-wechat-title="$route.meta.title">
    <pubHeaderNew ref="pubHeaderNew"></pubHeaderNew>
    <section class="pubContent first-bk">
      <div class="filterConArea">
        <div class="conArea-content clearfix" v-loading='dataLoading'>
          <div class="first-title">
            <img src="../../../static/img/news_gongshi.svg" alt="">
          </div>

            <div class="big-news">
              <div class="newslist clearfix" v-show="dataStatus" ref="newslist">

                <div class="list-item"  @click="newsDetail(index,item)"  v-for="(item,index) in showList" :key="index">
                  <div class="gr-dynamic-img" >
                    <img v-if="index==0" src="../../../static/news_img/news_post_3.png">
                    <img v-if="index==1" src="../../../static/news_img/news_post_4.png">
                    <img v-if="index==2" src="../../../static/news_img/news_post_7.jpg">
                    <img v-if="index==3" src="../../../static/news_img/news_post_8.jpg">
                    <img v-if="index==4" src="../../../static/news_img/news_post_5.png">
                    <img v-if="index==5" src="../../../static/news_img/news_post_6.png">
                    <img v-if="index==6" src="../../../static/news_img/news_post_1.png">
                    <img v-if="index==7" src="../../../static/news_img/news_post_2.png">
                    
                  </div>
                  <div class="item-info">
                    <p class="news-title">{{item.title}}</p>
                    <p class="news-date">{{item.releaseDate|formatDate}}</p>
                    <div class="news-text">
                      {{item.desc}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          <div class="arrow-box">
            <span class="left-arrow" @click="changePage('left')"></span>
            <span class="right-arrow" @click="changePage('right')"></span>
          </div>
        </div>
        <pubFooter></pubFooter>
      </div>
    </section>
  </div>
</template>

<script>

  // import THREE from 'three'
  // import { gb2big5 } from '@/utils/gb2big5.js'
  // import { formatDate } from '@/utils/date.js'
  import  Velocity from 'velocity-animate'
  import  { dataList } from '@/config/data'
  export default {
    name: "App",
    data() {
      return {
        dataLoading:false,
        height: "",
        showList:[],
        tenderList:[],
        bannerList:[],
        host:this.API.host,
        current_page:1,
        current_num:5,
        first:0,
        dataStatus:false,
        dataNumStatus:false,
      };
    },
    methods: {

      newsDetail(id,item){
        let left_num = 0;
        if(this.$refs.newslist.style.marginLeft!=''&& this.$refs.newslist.style.marginLeft!='0px'){
          left_num = parseInt(this.$refs.newslist.style.marginLeft.split('-')[1].split('px')[0]/320)
        }
        if(left_num>id){
          this.changePage('left')
        }else if(left_num+this.current_num<=id+1){
          this.changePage('right')
        }else{
          location.href='/newsDetail.html#/'+item.id
        }
      },

      getChana(list){
        let data = '';
        for(let i =0;i<list.length;i++){
          if(/[\u4E00-\u9FA5\uF900-\uFA2D]/.test(list[i])){
            data = list[i]
            break
          }
        }
        return data
      },

      changePage(id){
        let current_left = 0;
            if(this.$refs.newslist.style.marginLeft!=''&& this.$refs.newslist.style.marginLeft!='0px'){
              current_left = this.$refs.newslist.style.marginLeft.split('-')[1].split('px')[0]
            }
        if(id=='left'){
          if(current_left<=0){
            return false;
          }
          this.first = this.first-3;
          // this.first = this.first-6;
          if(this.first<=0){
            this.first =0
          }
          // this.getData(id);
          this.getAnimate(id)
        }else{
          this.first += this.current_page==1?0:6;
          if(!this.dataNumStatus){
            this.getData(id);
          }else{
            if(current_left/320+this.current_num<=this.showList.length){
              this.getAnimate(id)
            }
          }
        }
      },

      getAnimate(id){
        let current_left = 0;
        if(this.$refs.newslist.style.marginLeft!=''&& this.$refs.newslist.style.marginLeft!='0px'){
          current_left = this.$refs.newslist.style.marginLeft.split('-')[1].split('px')[0]
        }
        let current_right = this.current_page<=2?0:this.current_num*320;
        if(id=='right'&&this.dataNumStatus){
          if(current_left/320+this.current_num*2>=this.showList.length){
              current_right = 960;
              // current_right = (this.showList.length-this.current_num+1)*320;
              // current_right = (this.showList.length%this.current_num)*320;
            }

        }
        let length_b = 0;
        length_b = parseFloat(current_left)+current_right
        if(id=='left'){
          if(current_left<=0){
            return false;
          }
          // if(parseFloat(current_left)<parseFloat(current_right)){
            length_b = length_b - 960;
          // }
        }


        Velocity(this.$refs.newslist, {
          // opacity: 0.5,
          marginLeft:'-'+length_b+'px',
        }, {
          duration: 500,
        })
      },

      getData(id){
        if(this.dataNumStatus){
          return false
        }
        let matchReg = />.*?\<\/p/gi;
        dataList.forEach(ele=>{
          if(ele.picArr.length==0){
            ele.picArr[0]={}
          }
          ele.desc = ele.txt.replace(/<[^>]+>/g,"").replace(/&nbsp;/g,'')
        })
        this.showList = this.showList.concat(dataList)
        if(dataList.length<9){
          this.dataNumStatus = true;
        }
        this.dataStatus = true;
        this.getAnimate(id);

        return
        this.dataLoading = true;
        this.API.line.contentList({channelIds:"75",first:this.first,count:6,format:0}).then(res => {
          this.current_page +=1;
          this.dataLoading = false;
          this.dataStatus = true;

          // this.$nextTick(()=>{
            // setTimeout(() => {
              // this.showList = this.showList.push(res.body);
              res.body.forEach(ele=>{
                ele.picArr.length==0?ele.picArr[0]={}:'';
                let it= this.getChana(ele.txt.match(matchReg))
                ele.desc = ele.txt.replace(/<[^>]+>/g,"").replace(/&nbsp;/g,'')
              })
              this.showList = this.showList.concat(res.body)
              // if(this.current_page==2){
              //   return false
              // }
              if(res.body.length<6){
                this.dataNumStatus = true;
              }
              this.getAnimate(id);
              // this.dataStatus = false;
            // },500);
          // })

        }).catch(err => {
            console.log(err)
        })
      },

    },
    filters: {
      // formatDate (time) {
      //     var date = new Date(time)
      //     console.log(time,formatDate(date, 'yyyy/MM/dd'))
      //     return formatDate(date, 'yyyy/MM/dd')
      // }
      formatDate(value){
        return moment(value).format('YYYY-MM-DD')
      }
    },
    mounted() {
      this.getData('');
      this.$refs.pubHeaderNew.changeHeard(2)
      if(document.body.clientWidth>1790){
          this.current_num=6
        }else if(document.body.clientWidth>1450){
          this.current_num=5
        }else{
          this.current_num=4
        }
      window.onresize = () => {

        if(document.body.clientWidth>1790){
          this.current_num=6
        }else if(document.body.clientWidth>1450){
          this.current_num=5
        }else{
          this.current_num=4
        }
      }

      let SEPARATION = 100, AMOUNTX = 50, AMOUNTY = 50;

      let container;
      let camera, scene, renderer;

      let particles, particle, count = 0;

      let mouseX = -360, mouseY = -300;

      let windowHalfX = window.innerWidth / 2;
      let windowHalfY = window.innerHeight / 2;

      init();
      animate();
      function getRandomColor() {

        let r = 255*Math.random()|0,
          g = 255*Math.random()|0,
          b = 255*Math.random()|0;
        console.log( '0x' + parseInt(r, 16) + parseInt(g, 16) + parseInt( b, 16));
        return '0x' + parseInt(r, 16) + parseInt(g, 16) + parseInt( b, 16);
      }
      function init() {

        container = document.createElement( 'div' );
        container.style='position:fixed;bottom:-450px;z-index:5;';
        document.body.appendChild( container );

        camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 10000 );
        camera.position.z = 1000;
        if(document.body.clientHeight<=900){
          camera.position.z = 700;
        }
        scene = new THREE.Scene();

        particles = new Array();

        let PI2 = Math.PI * 2;
        let material = new THREE.ParticleCanvasMaterial( {
          // color: getRandomColor(),
          color: 0x3d8d8d8,
          program: function ( context ) {
            context.beginPath();
            context.arc( 0, 0, 1, 0, PI2, true );
            context.fill();

          }

        } );

        let i = 0;

        for ( let ix = 0; ix < AMOUNTX; ix ++ ) {

          for ( let iy = 0; iy < AMOUNTY; iy ++ ) {

            particle = particles[ i ++ ] = new THREE.Particle( material );
            particle.position.x = ix * SEPARATION - ( ( AMOUNTX * SEPARATION ) / 2 );
            particle.position.z = iy * SEPARATION - ( ( AMOUNTY * SEPARATION ) / 2 );
            scene.add( particle );

          }

        }

        renderer = new THREE.CanvasRenderer();
        renderer.setSize( window.innerWidth, window.innerHeight );
        container.appendChild( renderer.domElement );

        // document.addEventListener( 'mousemove', onDocumentMouseMove, false );
        // document.addEventListener( 'touchstart', onDocumentTouchStart, false );
        // document.addEventListener( 'touchmove', onDocumentTouchMove, false );

        //

        window.addEventListener( 'resize', onWindowResize, false );

      }

      function onWindowResize() {

        windowHalfX = window.innerWidth / 2;
        windowHalfY = window.innerHeight / 2;

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();

        renderer.setSize( window.innerWidth, window.innerHeight );

      }


      //

      function animate() {

        requestAnimationFrame( animate );

        render();


      }

      function render() {

        camera.position.x += ( mouseX - camera.position.x ) * .05;
        camera.position.y += ( - mouseY - camera.position.y ) * .05;
        camera.lookAt( scene.position );

        let i = 0;

        for ( let ix = 0; ix < AMOUNTX; ix ++ ) {

          for ( let iy = 0; iy < AMOUNTY; iy ++ ) {

            particle = particles[ i++ ];
            particle.position.y = ( Math.sin( ( ix + count ) * 0.3 ) * 50 ) + ( Math.sin( ( iy + count ) * 0.5 ) * 50 );
            particle.scale.x = particle.scale.y = ( Math.sin( ( ix + count ) * 0.3 ) + 1 ) * 2 + ( Math.sin( ( iy + count ) * 0.5 ) + 1 ) * 2;

          }

        }

        renderer.render( scene, camera );

        count += 0.1;

      }
    },
    updated() {},
    created() {}
  };
</script>
<style>
  .pubContent{
    overflow: hidden;
    background-position: center;
  }

  .gr-zhaob .footer,.gr-zhaob .footer .ft-footer{
    background-color: unset !important;
  }
</style>

<style scoped>
  @import url("../../../static/css/iconfont.css");
  @import url("../../assets/reset.css");

  #app {
    height: 100%;
  }
  .filterConArea{
    height: 80%;
  position: absolute;
  top:20%;
  width: 100%;

  }
  .conArea-content{
    position: absolute;
    /* top: 200px; */
    /* left: 7%; */
    width:100%;
    z-index: 10;
  }
  .line{
    margin: 20px 0 30px 0 ;
    width: 32px;
    border: 1px solid rgba(0,0,0,.85);
  }
  .newslist{

    width: 10000%;
    left: 10%;
    position:absolute;
    top: 0;
  }
  .big-news{
    width: 100%;
    margin-top: 64px;
    height: 416px;
    overflow: hidden;
    position: relative;
  }

  .list-item{
    background: #fff;
    border-radius: 8px;
    width: 300px;
    height: 400px;
    padding: 16px 16px 26px 16px;
    box-sizing: border-box;
    float: left;
    margin-right: 20px;
    border: 4px solid transparent;
    box-shadow:0px 10px 10px 0px rgba(0,0,0,0.03);
    margin-bottom: 40px;
    display: block;
    transition: all 0.5s;
  }
  .list-item:hover{
    border: 4px solid #0066FF;
  }
  .item-pic{
    width: 260px;
    height: 180px;
  }
  .item-pic img{
    width: 100%;
    height: 100%;
  }
  .news-title{
    font-weight: bold;
    color: rgba(0,0,0,.85);
    font-size: 16px;
    line-height: 21px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin: 12px 0;
  }
  .news-date{
    font-size: 12px;
    color: #999;
    line-height: 15px;
    margin-bottom: 9px;
  }
  .news-text{
    font-size: 14px;
    line-height: 24px;
    color: #999;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .arrow-box{
    text-align: center;
    margin-top: 60px;
  }
  .left-arrow,.right-arrow{
    display: inline-block;
    background-image: url('../../../static/imgnew/down-circle_gray.svg');
    height: 42px;
    width: 42px;
    margin: 0 10px;
    cursor: pointer;
  }
  .right-arrow{
    transform: rotate(180deg);
  }
  .left-arrow:hover,.right-arrow:hover{
    background-image: url('../../../static/imgnew/down-circle_black.svg');
  }

  .first-bk{
    background: #f5f5f5;
    height: 100%;
    width: 100%;
  }
  .footer{
    position: absolute;
    bottom: 0;
    z-index: 9;
    left: 0;
    /* padding: 0; */
  }
  .footer .header{
    position: initial;
  }
.first-title{
  margin-bottom: 30px;
  margin-left: 10%;
  width: 80%;
  position: relative;
}
.first-title::before{
  content: '';
  width:32px;
height:2px;
background:rgba(0,0,0,0.85);
position: absolute;
left: 0;
top: 45px;
}
.gr-dynamic-img{
  width: 260px;
  overflow: hidden;
  height: 180px;
  background-position: center;
  background-size: auto 100%;
  transition:background-size 0.3s;
}
@keyframes dynamicimgbig {
  from {
    background-size: auto 100%;
  }

  to {
    background-size: auto 120%;
  }
}
.list-item:hover .gr-dynamic-img{
  /* background-size: auto 120%; */
  /* animation: dynamicimgbig 0.3s; */
  background-size: auto 120%;
}

.list-item .gr-dynamic-img img{
  width: auto;
  height: 100%;
}
@keyframes mymove {
  from {
    /* -webkit-transform-origin: left bottom;
    transform-origin: left bottom; */
    transform: scale(0.5);
    /* -webkit-transform: rotate3d(0, 0, 1, 45deg);
    transform: rotate3d(0, 0, 1, 45deg); */
    opacity: 0;
  }

  to {
    /* -webkit-transform-origin: left bottom;
    transform-origin: left bottom; */
    transform: scale(1);
    /* -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0); */
    opacity: 1;
  }
}
@keyframes mymoveLeave {
  from{
    opacity: 1;
    transform: scale(1)
  }
  to{
    opacity: 0;
    transform: scale(0.5)
  }
}
/* .listName-enter{
  opacity: 0;
}
.listName-enter-to{
  animation: mymove 0.5s;
}
.listName-leave-to{
  animation: mymoveLeave 0.5s;
} */
</style>
